import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface EquipmentSelectionState {
  selectedEquipment: any[]
}

const initialState: EquipmentSelectionState = {
  selectedEquipment: []
}

const equipmentSelectionSlice = createSlice({
  name: 'equipmentSelection',
  initialState,
  reducers: {
    setSelectedEquipment: (state, action: PayloadAction<any[]>) => {
      state.selectedEquipment = action.payload
    },
    clearSelectedEquipment: state => {
      state.selectedEquipment = []
    },
    addSelectedEquipment: (state, action: PayloadAction<any>) => {
      const exists = state.selectedEquipment.find(item => item.id === action.payload.id)
      if (!exists) {
        state.selectedEquipment.push(action.payload)
      }
    },
    removeSelectedEquipment: (state, action: PayloadAction<string>) => {
      state.selectedEquipment = state.selectedEquipment.filter(item => item.id !== action.payload)
    }
  }
})

export const { setSelectedEquipment, clearSelectedEquipment, addSelectedEquipment, removeSelectedEquipment } =
  equipmentSelectionSlice.actions

export default equipmentSelectionSlice.reducer
